import React, { useState, useEffect } from 'react';
import Layout from '../layout/Layout';
import { PrivateAxios } from '../../request/axios';
import { toast } from 'react-toastify';

const CreerUtilisateur = () => {
    const [intermediaires, setIntermediaires] = useState([]);
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [intermediaireId, setIntermediaireId] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [loadingIntermediaires, setLoadingIntermediaires] = useState(true);
    const [error, setError] = useState(null);

    const fetchIntermediaires = async () => {
        try {
            const response = await PrivateAxios.get('/admin/intermediaire');
            setIntermediaires(response.data.int || []);
        } catch (err) {
            setError('Erreur lors du chargement des intermédiaires.');
            toast.error('Erreur lors du chargement des intermédiaires.');
        } finally {
            setLoadingIntermediaires(false);
        }
    };

    useEffect(() => {
        fetchIntermediaires();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!intermediaireId) {
            toast.error("L'intermédiaire est obligatoire.");
            return;
        }

        setIsSubmitting(true);

        const payload = {
            username,
            email,
            password,
            int_id: intermediaireId,
        };

        try {
            await PrivateAxios.post('/admin/creer/user', payload);
            toast.success('Utilisateur créé avec succès !');
            setUsername('');
            setEmail('');
            setPassword('');
            setIntermediaireId('');
        } catch (err) {
            toast.error('Erreur lors de la création de l\'utilisateur.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Layout>
            <h1 className="mb-6 text-3xl font-bold text-center text-black">Création d'un utilisateur</h1>

            <div className="flex justify-center">
                <form
                    onSubmit={handleSubmit}
                    className="w-full max-w-md p-8 transition-all duration-500 bg-white rounded-lg shadow-md hover:shadow-lg"
                >
                    {/* Champ Username */}
                    <div className="mb-4">
                        <label className="block mb-2 text-sm font-bold text-gray-700" htmlFor="username">
                            Nom d'utilisateur
                        </label>
                        <input
                            id="username"
                            type="text"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            placeholder="Entrez le nom d'utilisateur"
                            required
                            className="w-full px-3 py-2 transition-all duration-300 border rounded-lg shadow-sm focus:outline-none focus:ring focus:ring-blue-500 focus:border-blue-500"
                        />
                    </div>

                    {/* Champ Email */}
                    <div className="mb-4">
                        <label className="block mb-2 text-sm font-bold text-gray-700" htmlFor="email">
                            Email
                        </label>
                        <input
                            id="email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Entrez l'email"
                            required
                            className="w-full px-3 py-2 transition-all duration-300 border rounded-lg shadow-sm focus:outline-none focus:ring focus:ring-blue-500 focus:border-blue-500"
                        />
                    </div>

                    {/* Champ Password */}
                    <div className="mb-4">
                        <label className="block mb-2 text-sm font-bold text-gray-700" htmlFor="password">
                            Mot de passe
                        </label>
                        <input
                            id="password"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Entrez le mot de passe"
                            required
                            className="w-full px-3 py-2 transition-all duration-300 border rounded-lg shadow-sm focus:outline-none focus:ring focus:ring-blue-500 focus:border-blue-500"
                        />
                    </div>

                    {/* Champ Intermédiaire */}
                    <div className="mb-6">
                        <label className="block mb-2 text-sm font-bold text-gray-700" htmlFor="intermediaireId">
                            Intermédiaire
                        </label>
                        {loadingIntermediaires ? (
                            <p className="text-gray-500">Chargement des intermédiaires...</p>
                        ) : (
                            <select
                                id="intermediaireId"
                                value={intermediaireId}
                                onChange={(e) => setIntermediaireId(e.target.value)}
                                required
                                className="w-full px-3 py-2 transition-all duration-300 border rounded-lg shadow-sm focus:outline-none focus:ring focus:ring-blue-500 focus:border-blue-500"
                            >
                                <option value="">Sélectionner un intermédiaire</option>
                                {intermediaires.map((intermediaire) => (
                                    <option key={intermediaire.id} value={intermediaire.id}>
                                        {intermediaire.nom} - UG {intermediaire.ug_nom}
                                    </option>
                                ))}
                            </select>
                        )}
                    </div>

                    {/* Bouton de soumission */}
                    <div className="flex items-center justify-center">
                        <button
                            type="submit"
                            disabled={isSubmitting}
                            className={`px-4 py-2 bg-blue-600 text-white font-bold rounded-lg shadow-md hover:bg-blue-700 focus:outline-none transition-all duration-300 ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''
                                }`}
                        >
                            {isSubmitting ? 'Création en cours...' : 'Créer l\'utilisateur'}
                        </button>
                    </div>
                </form>
            </div>

            {/* Affichage des erreurs */}
            {error && <p className="mt-4 text-center text-red-500">{error}</p>}
        </Layout>
    );
};

export default CreerUtilisateur;
